// Ref: https://github.com/aavaz-ai/backend-monorepo/blob/master/serverless/shared/errors/codes.go#L1
// Note: add more codes when required
enum ErrorCode {
  UnprocessableEntity = 'ErrCodeUnprocessableEntity',
  RecordNotFound = 'ErrCodeRecordNotFound',
  DuplicateRecord = 'ErrCodeDuplicateRecord',
  InvalidRequestArgument = 'ErrCodeInvalidRequestArgument',
  UnauthorizedRequest = 'ErrCodeUnauthorized',
  InvalidSsoIdpToken = 'ErrCodeInvalidSsoIdpToken',
  UserUnapproved = 'ErrCodeUserUnapproved',
  UserSuspended = 'ErrCodeUserSuspended',
  TrialExpired = 'ErrCodeTrialExpired',
}

export default ErrorCode;
